export enum SubscriptionPlan {
    Demo = 1,
    Explorer = 2,
    Parent = 3,
    Professional = 4,
    UnregisteredUser = 5
}

export const SubscriptionPlanDescriptions = {
    [SubscriptionPlan.Demo]: 'Demo',
    [SubscriptionPlan.Explorer]: 'Explorer',
    [SubscriptionPlan.Parent]: 'Parent',
    [SubscriptionPlan.Professional]: 'Professional',
    [SubscriptionPlan.UnregisteredUser]: 'Unregistered User'
} as const; 